export default [
  {
    component: () => import('./Regulator.vue'),
    children: [
      {
        name: 'RegulatorHome',
        path: '/regulator',
        component: () => import('./content/RegulatorHome.vue'),
        meta: {
          title: 'Meus processos',
        },
        children: [
          {
            name: 'RegulatorAllProcesses',
            path: 'all',
            component: () => import('./content/RegulatorHome.vue'),
            meta: {
              title: 'Todos os processos',
            },
          },
          {
            name: 'RefulatorDeferred',
            path: 'deferred',
            component: () => import('./content/RegulatorHome.vue'),
            meta: {
              title: 'Deferidos',
            },
          },
          {
            name: 'RefulatorRejected',
            path: 'rejected',
            component: () => import('./content/RegulatorHome.vue'),
            meta: {
              title: 'Indeferidos',
            },
          },
          {
            name: 'RegulatorLegalReserve',
            path: 'legal-reserve',
            component: () => import('./content/RegulatorHome.vue'),
            meta: {
              title: 'Reserva legal',
            },
          },
          {
            name: 'RegulatorHighImpact',
            path: 'high-impact',
            component: () => import('./content/RegulatorHome.vue'),
            meta: {
              title: 'Alto impacto',
            },
          },
          {
            name: 'RegulatorSizeLarge',
            path: 'size-large',
            component: () => import('./content/RegulatorHome.vue'),
            meta: {
              title: 'Porte G',
            },
          },
          {
            name: 'RegulatorRadiation',
            path: 'radiation',
            component: () => import('./content/RegulatorHome.vue'),
            meta: {
              title: 'Radiação',
            },
          },
          {
            name: 'RegulatorDismissesLai',
            path: 'dismisses-lai',
            component: () => import('./content/RegulatorHome.vue'),
            meta: {
              title: 'Dispensa LAI',
            },
          },
        ],
      },
    ],
  },
];
